import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { AlertBadge } from './AlertBadge'
import { X } from 'lucide-react'
import { format } from 'date-fns'
import type { TriggeredAlert } from '@/types/alert.types'
import { useDismissAlert } from '@/hooks/useAlerts'

interface AlertCardProps {
  alert: TriggeredAlert
}

export const AlertCard = ({ alert }: AlertCardProps) => {
  const dismissAlert = useDismissAlert()

  const handleDismiss = () => {
    dismissAlert.mutate(alert.id)
  }

  return (
    <Card className="border-l-4 border-l-orange-500">
      <CardHeader className="flex flex-row items-start justify-between space-y-0 pb-3">
        <div className="space-y-1">
          <div className="flex items-center gap-2">
            <AlertBadge severity={alert.severityLevel} />
            <span className="text-sm text-muted-foreground">
              {format(new Date(alert.triggeredAt), 'MMM d, yyyy h:mm a')}
            </span>
          </div>
          <h3 className="font-semibold">{alert.deviceName}</h3>
          <p className="text-sm text-muted-foreground">{alert.accountName}</p>
        </div>
        {!alert.isDismissed && (
          <Button
            variant="ghost"
            size="icon"
            onClick={handleDismiss}
            disabled={dismissAlert.isPending}
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </CardHeader>
      <CardContent>
        <p className="text-sm">{alert.alertMessage}</p>
        {alert.paramLabel && (
          <p className="text-sm text-muted-foreground mt-2">
            {alert.paramLabel}: {alert.triggeredValue} {alert.unit}
          </p>
        )}
      </CardContent>
    </Card>
  )
}
